import { extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import createComponent from '../../../styles-system/create-component.esm.js';

var Component = createComponent('circle', 'csg-circle');
var Circle = /*#__PURE__*/React.forwardRef(function Circle(props, ref) {
  return /*#__PURE__*/React.createElement(Component, _extends({
    ref: ref
  }, props));
});

export default Circle;
//# sourceMappingURL=circle.esm.js.map
